import * as React from "react";
import { Paragraph } from "scuid-x";
import { GenErrorPage } from "../components/GenErrorPage";

export const MustGrantPermission: React.SFC<any> = () => {

  const description = (
    <Paragraph>
      You must grant permission for camera access in order to use instant verification. Please change your browser
      settings to allow access and then try again.
    </Paragraph>
  );

  return (
    <GenErrorPage
      title="Camera Access Required"
      description={description}
    />
  );
};



// WEBPACK FOOTER //
// ./src/screens/MustGrantPermission.tsx